// packages/shared-hooks/src/clients/useRestoreClientContact.ts
//
// `POST /clients/:id/contacts/:contactId/restore` — un-archives a
// contact. Backend rejects with 409 when the contact's phone is now
// claimed by a different active row (uniqueness slot collision).
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ClientContactSchema, type ClientContact } from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { clientsKeys } from './keys.js';

export function useRestoreClientContact(clientId: string, contactId: string) {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<ClientContact, unknown, void>({
    mutationFn: () =>
      client.post<ClientContact>(
        `/clients/${clientId}/contacts/${contactId}/restore`,
        undefined,
        {},
        ClientContactSchema,
      ),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: clientsKeys.detail(clientId) });
      void qc.invalidateQueries({ queryKey: clientsKeys.all });
    },
  });
}
